import { ReactNode } from 'react';

function Banner({ text }: { text: ReactNode }) {
  return (
    <div className="flex h-9 items-center justify-center bg-neutral-800">
      <p className="text-sm font-medium text-white">{text}</p>
    </div>
  );
}

export default Banner;
